// Cave84 — Producers service (Phase 1 Week 3)
// Read-focused: list, search (client-side prefix), getById.
// Create + update used by AddWine flow (owner-only).

import {
  addDoc, doc, getDoc, getDocs, orderBy,
  query, serverTimestamp, updateDoc
} from 'firebase/firestore';
import type { Producer } from '@cave84/shared-types';
import { db } from './firebase';
import { typedCollection } from './firestore';

const COLLECTION = 'producers';

export type ProducerCreateInput = Omit<Producer, 'id' | 'usage_count'>;
export type ProducerUpdateInput = Partial<Omit<Producer, 'id' | 'usage_count'>>;

function col() { return typedCollection<Producer>(COLLECTION); }

export async function listProducers(): Promise<Producer[]> {
  const snap = await getDocs(query(col(), orderBy('name', 'asc')));
  return snap.docs.map(d => d.data());
}

export async function getProducer(id: string): Promise<Producer | null> {
  const snap = await getDoc(doc(db, COLLECTION, id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...(snap.data() as Omit<Producer, 'id'>) };
}

export async function createProducer(input: ProducerCreateInput): Promise<Producer> {
  const payload = { ...input, usage_count: 0, created_at: serverTimestamp() };
  const ref = await addDoc(col(), payload as unknown as Producer);
  return { id: ref.id, usage_count: 0, ...input };
}

export async function updateProducer(id: string, patch: ProducerUpdateInput): Promise<void> {
  await updateDoc(doc(db, COLLECTION, id), patch);
}
